module.exports = __webpack_public_path__ + "static/media/attachment.4079ad8f.svg";